import GlobalBusy from "components/app/GlobalBusy";
import React, { useEffect } from "react";
import { Route, Redirect } from "react-router";
import authActions from "components/Auth/actions";
import { useSelector } from "react-redux";
import { AppRouteURI } from "./RoleBasedAccess";

const RouteAuth = ({ component: Component, ...rest }) => {
  const { loggedIn, fetching } = useSelector((state) => state.auth);
  const { loadMe } = authActions();

  useEffect(() => {
    if (!loggedIn) {
      loadMe();
    }
  }, [loadMe, loggedIn]);

  return (
    <Route
      {...rest}
      render={(props) => {
        const afterFetched = loggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect to={AppRouteURI.LOGIN} />
        );
        return fetching ? <GlobalBusy /> : afterFetched;
      }}
    />
  );
};

export default RouteAuth;
